export const labels = {
	noNameDefault: {
		label: "Label.MobileCreator.Options.None",
		default: "default",
	},

	specificNoOptions: (optionCode?: string) => {
		if (!optionCode) return undefined;
		return {
			label: `Label.MobileCreator.Options.None.${optionCode}`,
			default: "",
			logMissingToServer: false,
		};
	},
} as const;
